import {
  formatCEP,
  formatCpfCnpj,
  formatPhone,
  parseDateWithoutTimezone,
  validateCNPJ,
  validateCPF,
} from "./formatters";
import {
  TIPO_REPRESENTADO_PESSOA_FISICA,
  TIPO_REPRESENTADO_PESSOA_JURIDICA,
} from "./obterNomeExibicaoUsuario";
import { toISODate } from "./utils";

export const REPRESENTADO_CHAR_LIMITS = {
  nome: 150,
  sobrenome: 150,
  cpf: 18,
  cnpj: 18,
  email: 100,
  telefone: 15,
  rua: 100,
  numero: 10,
  municipio: 50,
  cep: 9,
  profissao: 50,
  empresa: 50,
  cargo: 50,
  razaoSocial: 150,
  nomeFantasia: 150,
  representanteLegal: 150,
};

const apenasDigitos = (valor) => (valor ?? "").replace(/\D/g, "");

export function criarFormularioRepresentadoVazio(
  tipo = TIPO_REPRESENTADO_PESSOA_FISICA,
) {
  return {
    tipo,
    nome: "",
    sobrenome: "",
    documento: "",
    dataNascimento: null,
    email: "",
    telefone: "",
    profissao: "",
    empresa: "",
    cargo: "",
    razaoSocial: "",
    nomeFantasia: "",
    dataConstituicao: null,
    representanteLegal: "",
    enderecoId: null,
    rua: "",
    numero: "",
    municipio: "",
    estado: "",
    cep: "",
  };
}

export function montarFormularioDeRepresentado(representado) {
  const numeroEndereco = representado?.endereco?.numero;
  const cepEndereco = representado?.endereco?.cep;

  return {
    ...criarFormularioRepresentadoVazio(
      representado?.tipo ?? TIPO_REPRESENTADO_PESSOA_FISICA,
    ),
    nome: representado?.nome || "",
    sobrenome: representado?.sobrenome || "",
    documento: representado?.cpf ? formatCpfCnpj(String(representado.cpf)) : "",
    dataNascimento: parseDateWithoutTimezone(representado?.dataNascimento),
    email: representado?.email || "",
    telefone: representado?.telefone ? formatPhone(representado.telefone) : "",
    profissao: representado?.profissao || "",
    empresa: representado?.empresa || "",
    cargo: representado?.cargo || "",
    razaoSocial: representado?.razaoSocial || "",
    nomeFantasia: representado?.nomeFantasia || "",
    dataConstituicao: parseDateWithoutTimezone(representado?.dataConstituicao),
    representanteLegal: representado?.representanteLegal || "",
    enderecoId: representado?.endereco?.id || representado?.enderecoId || null,
    rua: representado?.endereco?.rua || "",
    numero:
      numeroEndereco !== null && numeroEndereco !== undefined
        ? String(numeroEndereco)
        : "",
    municipio: representado?.endereco?.municipio || "",
    estado: representado?.endereco?.estado || "",
    cep:
      cepEndereco !== null && cepEndereco !== undefined
        ? formatCEP(String(cepEndereco).padStart(8, "0"))
        : "",
  };
}

export function montarPayloadRepresentado(formulario, semNumero = false) {
  const isPessoaJuridica =
    formulario.tipo === TIPO_REPRESENTADO_PESSOA_JURIDICA;

  const endereco = {
    rua: formulario.rua,
    numero: semNumero ? null : formulario.numero || null,
    municipio: formulario.municipio,
    estado: formulario.estado,
    cep: apenasDigitos(formulario.cep),
  };
  if (formulario.enderecoId) {
    endereco.id = formulario.enderecoId;
  }

  const dadosComuns = {
    tipo: formulario.tipo,
    cpf: apenasDigitos(formulario.documento),
    email: formulario.email.trim(),
    telefone: apenasDigitos(formulario.telefone),
    endereco,
  };

  if (isPessoaJuridica) {
    return {
      ...dadosComuns,
      razaoSocial: formulario.razaoSocial,
      nomeFantasia: formulario.nomeFantasia,
      dataConstituicao: toISODate(formulario.dataConstituicao),
      representanteLegal: formulario.representanteLegal,
    };
  }

  return {
    ...dadosComuns,
    nome: formulario.nome,
    sobrenome: formulario.sobrenome,
    dataNascimento: toISODate(formulario.dataNascimento),
    profissao: formulario.profissao || null,
    empresa: formulario.empresa || null,
    cargo: formulario.cargo || null,
  };
}

export function validarFormularioRepresentado(formulario, semNumero = false) {
  const erros = [];
  const isPessoaJuridica =
    formulario.tipo === TIPO_REPRESENTADO_PESSOA_JURIDICA;
  const documentoDigitos = apenasDigitos(formulario.documento);

  if (!formulario.email?.trim()) {
    erros.push("O email é obrigatório.");
  }

  if (isPessoaJuridica) {
    if (documentoDigitos.length !== 14 || !validateCNPJ(documentoDigitos)) {
      erros.push("CNPJ inválido.");
    }
    if (toISODate(formulario.dataConstituicao) === null) {
      erros.push("Data de constituição inválida.");
    }
  } else {
    if (documentoDigitos.length !== 11 || !validateCPF(documentoDigitos)) {
      erros.push("CPF inválido.");
    }
    if (toISODate(formulario.dataNascimento) === null) {
      erros.push("Data de nascimento inválida.");
    }
  }

  if (!semNumero && !formulario.numero?.trim()) {
    erros.push("O número do endereço é obrigatório.");
  }

  return erros;
}
